export default __webpack_public_path__ + "9c8a2cc1ffdc99d51d26baf300c14e8c.svg";